import React from "react";
import { Avatar, Tooltip } from "@mui/material";

const getOwnerInitials = (name, email) => {
  if (name) {
    const parts = name.trim().split(/\s+/);
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  }
  if (email) return email[0].toUpperCase();
  return "U";
};

const ControlOwnerAvatar = ({
  owner,
  onClick,
  size = 32,
  fontSize = "0.75rem",
  fontWeight = 600,
  placement = "top",
}) => {
  const isUnassigned = !owner?.name && !owner?.email;
  const tooltipLabel = isUnassigned
    ? onClick
      ? "Unassigned - click to assign"
      : "Unassigned"
    : `${[owner?.name, owner?.email].filter(Boolean).join(" · ")}${onClick ? " - click to change" : ""
    }`;

  return (
    <Tooltip title={tooltipLabel} arrow placement={placement}>
      <Avatar
        onClick={onClick}
        sx={{
          width: size,
          height: size,
          fontSize,
          fontWeight,
          backgroundColor: isUnassigned ? "#F3F4F6" : "#E8EDF8",
          color: isUnassigned ? "#9CA3AF" : "#031B89",
          border: `1.5px solid ${isUnassigned ? "#E5E7EB" : "#C7D3F5"}`,
          cursor: onClick ? "pointer" : "default",
          transition: "box-shadow 0.15s",
          "&:hover": onClick ? { boxShadow: "0 0 0 3px rgba(3,27,137,0.15)" } : {},
        }}
      >
        {isUnassigned ? "U" : getOwnerInitials(owner?.name, owner?.email)}
      </Avatar>
    </Tooltip>
  );
};

export default ControlOwnerAvatar;
